var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitLoss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 48,
    viewBox: "0 0 60 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 48,
    rx: 5,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5782 27.6587H23.4924C23.1915 27.6587 22.9478 27.9024 22.9478 28.2034V36.0996C22.9478 36.4006 23.1915 36.6443 23.4924 36.6443H28.5782C28.8791 36.6443 29.1225 36.4006 29.1225 36.0996V28.203C29.1225 27.902 28.8788 27.6587 28.5782 27.6587Z",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5078 11.3561H31.4221C31.1212 11.3561 30.8774 11.5998 30.8774 11.9008V36.0992C30.8774 36.4002 31.1212 36.6439 31.4221 36.6439H36.5078C36.8088 36.6439 37.0525 36.4002 37.0525 36.0992V11.9008C37.0525 11.5998 36.8088 11.3561 36.5078 11.3561Z",
    fill: "#828282"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4781 18.7076H39.3923C39.0914 18.7076 38.8477 18.9514 38.8477 19.2523V36.0992C38.8477 36.4002 39.0914 36.6439 39.3923 36.6439H44.4777C44.7787 36.6439 45.0224 36.4002 45.0224 36.0992V19.2523C45.0224 18.9517 44.7787 18.7076 44.4781 18.7076Z",
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6075 18.7076H15.5217C15.2208 18.7076 14.9771 18.9514 14.9771 19.2523V36.0992C14.9771 36.4002 15.2208 36.6439 15.5217 36.6439H20.6075C20.9084 36.6439 21.1521 36.4002 21.1521 36.0992V19.2523C21.1521 18.9517 20.9084 18.7076 20.6075 18.7076Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitLoss);
export default __webpack_public_path__ + "static/media/profit-loss.efb7c345d74cd0a1f593faad339ddcf9.svg";
export { ForwardRef as ReactComponent };